import { QuoteService } from 'quote-domain-core';
import { AbstractPriceEngineCalculator } from './abstract-price-engine-calculator';
import {singleton} from "tsyringe";
import {VtCorridorCalculatorFactory} from "./vt/vt-corridor-calculator-factory";

@singleton()
export class PriceEngineConfigCalculator {

    constructor(
        private readonly vtCorridorCalculatorFactory: VtCorridorCalculatorFactory
    ) {}

    getCalculatorInstance(
        countryIsoCode: string,
        role: string,
        serviceCode: string,
        region: string,
        quoteService: QuoteService,
        referential: any,
        referentialService: any
    ): AbstractPriceEngineCalculator | undefined {

        const config: Record<string, Record<string, Record<string, () => AbstractPriceEngineCalculator>>> = {
            FR: {
                CA_ICS_VT: {
                    VT: () => this.vtCorridorCalculatorFactory.create(
                        quoteService,
                        referential,
                        referentialService,
                        region
                    )
                }
            }
        };

        return config[countryIsoCode]?.[role]?.[serviceCode]?.();
    }
}
